import { render } from "./CurrentMessageView.vue?vue&type=template&id=61cd1e6a"
import script from "./CurrentMessageView.vue?vue&type=script&lang=js"
export * from "./CurrentMessageView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__